import { Card, Flex, Space, Typography } from 'antd';
import React from 'react';

const { Title } = Typography;

interface TableContainerProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export default function TableContainer({
  title,
  children,
  actions,
  className = '',
}: TableContainerProps) {
  return (
    <Card
      className={className}
      title={
        <Flex
          justify="space-between"
          align="center"
          wrap="wrap"
          gap={8}
          style={{ minHeight: 40 }}
        >
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
          {actions && <Space wrap>{actions}</Space>}
        </Flex>
      }
      styles={{
        header: { padding: '8px 20px' },
        body: { padding: 0, overflowX: 'auto' },
      }}
    >
      {children}
    </Card>
  );
}
